"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_social__youtube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333",
      strokeWidth: 0
    },
    d: "M174.2,62.6a20.6,20.6,0,0,0-17.9-18.1,468.12,468.12,0,0,0-120.6,0A20.5,20.5,0,0,0,17.9,62.6a299.31,299.31,0,0,0,0,66.9,20.5,20.5,0,0,0,17.8,18.1,468.8,468.8,0,0,0,60.4,3.9,467.26,467.26,0,0,0,60.3-3.9,20.5,20.5,0,0,0,17.8-18.1A288.13,288.13,0,0,0,176.1,96a286.42,286.42,0,0,0-1.9-33.4M119.3,99.2,86.5,122.3a2.89,2.89,0,0,1-4-.7,2.62,2.62,0,0,1-.5-1.7V72a2.88,2.88,0,0,1,2.8-2.9,3.37,3.37,0,0,1,1.7.5l32.8,23.1a3.89,3.89,0,0,1,.9,5.5,3,3,0,0,1-.9,1"
  }));
}

var _default = ic_social__youtube;
exports.default = _default;